"use client";

import { useAppContext } from "@/context/Context";
import Image from "next/image";
import logo from "../../public/images/logo/logo.webp";
import logoDark from "../../public/images/light/logo/logo-dark.webp";

/**
 * Componente de carga que muestra una animación de procesamiento.
 * Utiliza el contexto de la aplicación para determinar el tema actual y seleccionar el logo adecuado.
 *
 * @returns {JSX.Element|null} - Elemento de carga o null si el tema aún no está definido.
 */
export default function Loading() {
  const { isLightTheme } = useAppContext();

  // Si el estado del tema no está definido, no se renderiza nada.
  if (isLightTheme === undefined) {
    return null;
  }

  return (
    <div className="loading-overlay">
      <main className="page-wrapper">
        <div className="signup-area">
          <div className="wrapper">
            <div className="row">
              <div className="col-lg-12 left-wrapper">
                <div className="sign-up-box general-purpouse-box">
                  <div className="signup-box-top">
                    <Image
                      src={isLightTheme ? logo : logoDark}
                      width={193}
                      height={50}
                      alt="sign-up logo"
                    />
                  </div>
                  <div className="signup-box-bottom text-center">
                    <div className="loading">
                      <h3>Procesando</h3>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
